import { BatchApiAdapter } from '@modules/Batches/adapters/BatchApiAdapter';
import type { HttpClient } from '@adapters/HttpClient';
import type { LoadOptionsResponse } from '@shared/components/ui/MultiSelect';

type PaginatedListParams = { search: string; page: number; limit: number };

/** Carga lotes paginados para MultiSelect (mismo contrato que el listado /batches). */
export async function loadBatchesForMultiSelect(
  httpClient: HttpClient,
  params: PaginatedListParams,
): Promise<LoadOptionsResponse> {
  try {
    const adapter = new BatchApiAdapter(httpClient);
    const search = params.search.trim();

    const result = await adapter.getBatchesPaginated({
      page: params.page,
      limit: params.limit,
      sortBy: 'batch_number',
      sortDirection: 'asc',
      ...(search
        ? {
            advanced_filters: {
              filters: [
                { column: 'batch_number', operator: 'contains', value: search },
                { column: 'supplier_reference', operator: 'contains', value: search },
              ],
              logic: 'OR',
            },
          }
        : {}),
    });

    return {
      options: result.batches.map((batch) => ({
        value: String(batch.id),
        label: batch.batch_number?.trim() || `LOT-${batch.id}`,
      })),
      hasMore: result.hasMore,
    };
  } catch (error) {
    console.error('[loadBatchesForMultiSelect]', error);
    return { options: [], hasMore: false };
  }
}
